/**
 * Provides an error components.
 */

import * as React from 'react';

import { ViewStyle, View, TouchableOpacity } from 'react-native';
import styled from 'styled-components';

import { Colors } from 'theme/colors';
import { ErrorCloseIcon } from 'theme/icons';
import { ErrorText } from 'theme/text';
import { BORDER_RADIUS, CLOSE_ICON_SIZE, HEADER_HIT_SLOP } from 'theme/sizes';

const ErrorView = styled(View)`
  background-color: ${Colors.lightGrey};
  border-top-left-radius: ${BORDER_RADIUS};
  border-top-right-radius: ${BORDER_RADIUS};
  flex-direction: row;
  margin-left: 40;
  margin-right: 40;
  padding-left: 4;
`;

const CloseErrorButton = styled(TouchableOpacity)`
  align-items: center;
  justify-content: center;
`;

interface InlineErrorProps {
  error?: string;
  isStandalone?: boolean;
  style?: ViewStyle;
  onClearError?(): void;
}

export const InlineError = ({ isStandalone, onClearError, error, style }: InlineErrorProps) => {
  if (!error) {
    return null;
  }

  const radius = isStandalone ? BORDER_RADIUS : 0;
  const borderStyle = {
    borderBottomLeftRadius: radius,
    borderBottomRightRadius: radius,
  };

  return (
    <ErrorView style={[style, borderStyle]}>
      <CloseErrorButton hitSlop={HEADER_HIT_SLOP} onPress={onClearError}>
        <ErrorCloseIcon name="close" size={CLOSE_ICON_SIZE} />
      </CloseErrorButton>
      <ErrorText>{error}</ErrorText>
    </ErrorView>
  );
};
